<template>
  <div class="dropdown admin-profile">
    <div
        class="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
    >
      <div class="flex-shrink-0">
        <img
            class="rounded-circle wh-40 administrator"
            src="/images/admin.png"
            alt="admin"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-none d-xxl-block">
            <div class="d-flex align-content-center">

<!--              <h3>{{ authStore.user?.name }}</h3>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-menu border-0 bg-white dropdown-menu-end">
      <div class="d-flex align-items-center info">
        <div class="flex-shrink-0">
          <img
              class="rounded-circle wh-30 administrator"
              src="/images/admin.png"
              alt="admin"
          />
        </div>
        <div class="flex-grow-1 ms-2">
          <h3 class="fw-medium">{{ authStore.user?.name }}</h3>
<!--          <span class="fs-12">{{ authStore.user?.roles[0] }}</span>-->
        </div>
      </div>

      <ul class="admin-link ps-0 mb-0 list-unstyled">
        <li v-if="!$route.fullPath.includes('legal')">
          <RouterLink
              class="dropdown-item d-flex align-items-center text-body"
              :to="profileLink"
          >
            <i class="material-symbols-outlined">account_circle</i>
            <span class="ms-2">Профиль</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink v-if="$route.fullPath.includes('legal')"
              class="dropdown-item d-flex align-items-center text-body"
              to="/legal/authentication/logout"
          >
            <i class="material-symbols-outlined">logout</i>
            <span class="ms-2">Выйти</span>
          </RouterLink>
          <RouterLink v-else
                      class="dropdown-item d-flex align-items-center text-body"
                      to="/authentication/logout"
          >
            <i class="material-symbols-outlined">logout</i>
            <span class="ms-2">Выйти</span>
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import {useAuthStore} from "@/stores/auth";
import {computed} from 'vue';
import {useRoute} from 'vue-router';

const authStore = useAuthStore();
const route = useRoute();

const profileLink = computed(() => {
  // Check if current route is the reports page
  if (route.name === 'ReportsManage') { // Adjust this to match your actual route name
    return '/my-profile?is_from_reports=1';
  }
  return '/my-profile';
});
</script>

<style>

.dropdown-toggle:after {
  display: none;
}

.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: white;
}
</style>